import styled from 'styled-components'

import { toRem } from 'styles'

type Props = {
	isVisible: boolean
}

export const Container = styled.div<Props>`
	display: ${({ isVisible }) => (isVisible ? 'inline-block' : 'none')};
	text-align: left;
	margin-top: 8px;
	color: ${({ theme }) => theme.color.danger};
	font-size: ${toRem(14)};
`
